/*
 * @Description:
 * @Author: zhanghao
 * @Date: 2025-11-04 13:50:42
 * @LastEditTime: 2026-05-28 15:29:07
 * @LastEditors: zhanghao
 */
// 初始化数据
const modals = {
  submitData: {}, //基本信息数据
  uploadData: {}, //补充协议数据
  showTab: '1', //标识的tab（基本信息，补充协议）
  TaxCodeOrgName: {}, //税号和机构名称
  supplierData: '', //供应商
  operatorAuthTemplateUrl: '', //经办人授权书模板url
  personalIdentity3Key: null, //个人三要素验证key-获取验证码返回的result
  pageInfo: {}, //云签申请数据
};
export default modals;
